/**
 * The sidebar's logo mark, served from `public/` rather than imported.
 *
 * `public/index.html` paints the shell before the app loads (#667), logo
 * included. Imported, the image would be a hashed `/static/media/` file the
 * browser has not fetched when React replaces that first paint, and the
 * logo would blink out; at one URL it is already loaded and decoded.
 */
export const LOGO_URL = `${process.env.PUBLIC_URL}/epic-hoas-icon.png`;
